import { type ProductAdds } from '../types';

// ─────────────────────────────────────────────────────────────────────────────

/**
 * Starts an "add to bag" run with every product still to be sent.
 */
export function createProductAdds(selectionIds: string[]): ProductAdds {
  return {
    queue: selectionIds,
    inFlight: [],
    added: [],
    failed: [],
  };
}
